<template>
  <form @submit.prevent="submit" :class="errorClass">

    <div class="inline">
      <rp-select
        v-model="resource.numKeys"
        placeholder="Number of Keys"
        class="inline-child"
        @input="touch('numKeys')"
        isRequired>
        <option v-for="n in numKeyRange" :key="n" :value="n">{{n}}</option>
      </rp-select>

      <rp-select
        v-model="resource.duration"
        placeholder="Key Duration (Months)"
        class="inline-child"
        @input="touch('duration')"
        isRequired>
        <option v-for="n in durationKeyRange" :key="n" :value="n">{{n}}</option>
      </rp-select>
    </div>

    <rp-button :disabled="isInvalid" type="primary">Generate</rp-button><br/>

    <rp-textbox
      v-model="resource.result"
      helperText="Generated keys"
      :rows=12
      :disabled=true
    />

  </form>
</template>

<script>
  import {validationMixin} from 'vuelidate'
  import {email, required} from 'vuelidate/lib/validators'
  import {errorMessages} from '../../../api/error_messages'

  import form from '../../../mixins/form'

  import Button from '../../../components/ui/inputs/Button'
  import Select from '../../../components/ui/inputs/StyledSelect'  
  import TextInput from '../../../components/ui/inputs/TextInput'
  import TextBox from '../../../components/ui/inputs/TextBox'

  export default {
    name: 'GenerateRegistrationKeys',
    mixins: [validationMixin, form],

    components: {
      'rp-button': Button,
      'rp-select': Select,
      'rp-textinput': TextInput,
      'rp-textbox': TextBox
    },

    props: {
    },

    data() {
      return {
        numKeyRange: [],
        durationKeyRange: []
      }
    },

    mounted() {
      for (let i = 1; i <= 100; i++) {
        this.numKeyRange.push(i)
      }
      for (let i = 6; i <= 36; i = i + 6) {
        this.durationKeyRange.push(i)
      }
    },

    computed: {
    },

    methods: {
    },

    validations: {
      resource: {
        numKeys: {required},
        duration: {required}
      }
    }
  }
</script>

<style lang="sass" scoped>
  div
    .inline
      display: flex
      .inline-child
        margin: 10px
</style>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/forms/GenerateRegistrationKeys.vue